module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (165).61df7cbf.jpg";